export default __webpack_public_path__ + "static/media/intro-promo.fc5f592a.png";